/*--------------------------------------------------------------
# Custom scripts for Card grid block
--------------------------------------------------------------*/

var cardGridSlider = jQuery('.card-grid-slider');

if (cardGridSlider.length > 0) {
    const cardGridSettings = {
        adaptiveHeight: true,
        arrows: true,
        dots: true,
        infinite: true,
        nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right-simplified" aria-hidden="true"></span></button>',
        prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left-simplified" aria-hidden="true"></span></button>',
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 576,
                settings: "unslick"
            }
        ]
    };
   
    const cardGridSliderInit =  jQuery('.card-grid-slider').slick(cardGridSettings);
         
    jQuery(window).on('resize load', function() {
        // init slider with above settings
        if( jQuery(window).width() < 576 && !cardGridSliderInit.hasClass('slick-initialized')) {
            jQuery('.card-grid-slider').slick(cardGridSettings);
        }

        // when not a slider change and remove tab indexes set by slick to allow keyboard users to tab through link
        if( jQuery(window).width() > 576 && !cardGridSliderInit.hasClass('slick-initialized')) {
            jQuery(".card-grid-slider__item").removeAttr("tabindex", "0");
            jQuery(".card-grid-slider__item .btn-link").attr("tabindex", "0");
        }
    });
}